import React from 'react';
import { Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';
import { Link } from 'react-router-dom';
export const Footer = () => {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-gray-900 text-white" data-id="element-182">
      <div className="container mx-auto px-4 py-12" data-id="element-183">
        <div className="grid md:grid-cols-4 gap-8" data-id="element-184">
          <div className="md:col-span-1" data-id="element-185">
            <h3 className="text-xl font-bold mb-4" data-id="element-186">
              Life<span className="text-amber-400" data-id="element-187">Fort</span> Solutions
            </h3>
            <p className="text-gray-400 mb-4" data-id="element-188">
              Transforming ideas into impact across Africa and the Diaspora
              since 2019.
            </p>
            <div className="flex space-x-4" data-id="element-189">
              <a href="#" className="text-gray-400 hover:text-white transition" data-id="element-190">
                <Facebook size={20} data-id="element-191" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition" data-id="element-192">
                <Twitter size={20} data-id="element-193" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition" data-id="element-194">
                <Linkedin size={20} data-id="element-195" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition" data-id="element-196">
                <Instagram size={20} data-id="element-197" />
              </a>
            </div>
          </div>
          <div data-id="element-198">
            <h4 className="font-bold mb-4" data-id="element-199">Our Services</h4>
            <ul className="space-y-2 text-gray-400" data-id="element-200">
              <li data-id="element-201">
                <a href="/#services" className="hover:text-amber-400 transition" data-id="element-202">
                  IDEAS
                </a>
              </li>
              <li data-id="element-203">
                <a href="/#services" className="hover:text-amber-400 transition" data-id="element-204">
                  STRATEGY
                </a>
              </li>
              <li data-id="element-205">
                <a href="/#services" className="hover:text-amber-400 transition" data-id="element-206">
                  EXECUTION
                </a>
              </li>
              <li data-id="element-207">
                <a href="/#approach" className="hover:text-amber-400 transition" data-id="element-208">
                  Our Approach
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-209">
            <h4 className="font-bold mb-4" data-id="element-210">Company</h4>
            <ul className="space-y-2 text-gray-400" data-id="element-211">
              <li data-id="element-212">
                <a href="/#about" className="hover:text-amber-400 transition" data-id="element-213">
                  About Us
                </a>
              </li>
              <li data-id="element-214">
                <Link to="/insights" className="hover:text-amber-400 transition" data-id="element-215">
                  Insights
                </Link>
              </li>
              <li data-id="element-216">
                <a href="#" className="hover:text-amber-400 transition" data-id="element-217">
                  Our Team
                </a>
              </li>
              <li data-id="element-218">
                <a href="#" className="hover:text-amber-400 transition" data-id="element-219">
                  Careers
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-220">
            <h4 className="font-bold mb-4" data-id="element-221">Legal</h4>
            <ul className="space-y-2 text-gray-400" data-id="element-222">
              <li data-id="element-223">
                <a href="#" className="hover:text-amber-400 transition" data-id="element-224">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-225">
                <a href="#" className="hover:text-amber-400 transition" data-id="element-226">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-227">
                <a href="#" className="hover:text-amber-400 transition" data-id="element-228">
                  Cookie Policy
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-500" data-id="element-229">
          <p data-id="element-230">&copy; {currentYear} Life Fort Solutions. All rights reserved.</p>
        </div>
      </div>
    </footer>;
};